import EE from '~/listenerEventService/EventEmitter';
import { clickstreamLogger } from '~/logging';
import settings from '~/utils/Settings';

export default class FieldListener extends EE implements IListener {
  timerId: number = null;

  get interval() {
    return settings.getOrDefault('FIELDS_INFO_INTERVAL', 500);
  }

  timeoutHandler = () => {
    this.emit('analytics', {
      type: 'fields-info',
      forms: document.forms,
      save: false,
    });
  }

  start() {
    if (!this.timerId) {
      this.timerId = window.setInterval(this.timeoutHandler, this.interval);
    }

    clickstreamLogger.debug('Field listener started');
  }

  stop() {
    if (this.timerId) {
      clearInterval(this.timerId);
      this.timerId = null;
    }

    clickstreamLogger.debug('Field listener stopped');
  }
}
